<template>
  <div class="d-flex flex-column ml-4 mr-4 sidebar-preferences-wrapper">
    <p
      :class="[notValidCustomer ? 'mt-3' : 'mt-5']"
      class="primary--text font-family-regular mb-3 font-size-md"
    >
      Preferences
    </p>
    <div v-if="sidebarPreferences.length > 0">
      <div
        class="preferences-card-wrapper"
        v-for="preference in sidebarPreferences"
        :key="preference.id"
      >
        <b-card
          class="border-primary-lighter preferences-categories-card cursor-pointer"
          no-body
          @click="copyPreference(preference)"
        >
          <b-card-body class="px-4 py-3">
            <div
              class="d-flex position-relative flex-column p-2 pt-3 carousel-outer-container"
            >
              <p class="primary--text font-family-medium mb-4">
                {{ preference.title }}
              </p>
              <vue-carousel
                :controls="preference.descriptions.length > 1"
                :autoplay="false"
                direction="right"
                :data="preference.descriptions"
              ></vue-carousel>
            </div>
          </b-card-body>
        </b-card>
      </div>
    </div>
    <div v-else>
      <p class="primary--text font-family-regular mb-5 mt-4">
        No preferences to show
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "PreferencesComponent",
  props: ["notValidCustomer", "sidebarPreferences"],
  methods: {
    async copyPreference(preference) {
      try {
        // Create the content exactly as it appears in your interface
        const title = preference.title;
        const descriptions = preference.descriptions || [];

        // Build HTML content that preserves the original formatting
        let htmlContent = `<div>`;
        htmlContent += `<p><strong>${title}</strong></p>`;

        descriptions.forEach(description => {
          htmlContent += `<p>${description}</p>`;
        });

        htmlContent += `</div>`;

        // Build plain text content
        let textContent = title + "\n\n";
        textContent += descriptions.join("\n");

        // Try to copy both HTML and plain text
        if (navigator.clipboard && window.ClipboardItem) {
          const htmlBlob = new Blob([htmlContent], { type: "text/html" });
          const textBlob = new Blob([textContent], { type: "text/plain" });

          await navigator.clipboard.write([
            new window.ClipboardItem({
              "text/html": htmlBlob,
              "text/plain": textBlob,
            }),
          ]);
        } else {
          // Fallback to plain text only
          await navigator.clipboard.writeText(textContent);
        }

        // Show success message
        this.$bvToast.toast("Preference copied to clipboard!", {
          title: "Copied",
          variant: "success",
          solid: true,
        });
      } catch (error) {
        console.error("Failed to copy:", error);

        // Final fallback - manual copy
        try {
          const fallbackText = `${
            preference.title
          }\n\n${preference.descriptions.join("\n")}`;
          await navigator.clipboard.writeText(fallbackText);

          this.$bvToast.toast("Copied as plain text", {
            title: "Copied",
            variant: "info",
            solid: true,
          });
        } catch (finalError) {
          this.$bvToast.toast("Copy failed. Please try again.", {
            title: "Error",
            variant: "danger",
            solid: true,
          });
        }
      }
    },
  },
};
</script>

<style scoped lang="scss">
@import "~@/scss/variables/colors.scss";

.cursor-pointer {
  cursor: pointer;
}

.breadcrumb-container-left {
  left: 0;
}
.customer-details {
  right: 2%;
  overflow-wrap: break-word;
}
.preferences-card-wrapper {
  margin-bottom: 3rem;
}
.preferences-categories-card {
  border-radius: 10px;
}
.sidebar-preferences-wrapper {
  margin-bottom: 10rem;
}
.add-attachment-top {
  top: 0.8rem;
}
.tasks-attachment-card {
  width: inherit;
  border: 1px solid #dcebf4 !important;
  height: 4rem;
  padding-left: 1.2rem;
  padding-right: 1.2rem;
}
.high-priority-text {
  margin: 2px;
}
.tasks-form-card {
  height: 4rem;
}
.comment-card-body {
  width: 30rem;
}
.tasks-vertical-divider {
  border-left: 1px solid $primary-lighter;
  top: 3rem;
}
.add-comment-input-box {
  height: 4rem;
  min-height: 4.4rem;
}
.remove-option-icon {
  right: 0.5rem;
}
.start-timer-btn {
  padding: 1rem 2rem !important;
}
.start-timer-btn p,
.timer-running-container p {
  color: #784f89;
  top: 1.3rem;
}
.checkbox-title-container {
  z-index: 0;
  top: 0.2rem;
}
.attachment-name {
  font-size: 1.5rem !important;
}
.show-timer p {
  top: 1.2rem;
}
.attachment-delete-btn,
.checklist-delete-btn {
}
.checklist-options-container {
  margin-bottom: 2.4rem;
}
.tasks-dropdown-divider {
  margin-top: 2.5rem;
}
.tasks-right-container {
  position: fixed;
  right: 0;
  z-index: 2;
  display: flex;
  top: 9rem;
  background: #fff;
  height: 100vh;
  overflow-y: auto;
}
.input-icon-container {
  right: 1rem;
  top: 1.2rem;
}
.box-container {
  height: 10rem;
  border-radius: 6px;
  width: 15rem;
}
.show-timer-container {
  margin-top: -6rem;
}
.box-container a {
  opacity: 0.3;
}
.box-container.thumbnail-wrapper {
  > img {
    width: 100%;
    height: 100%;
    cursor: pointer;
  }
}
.tasks-preferences {
  z-index: 100000;
  width: inherit;
}
.timer-resume {
  right: -1.5px;
  cursor: pointer;
}
.tasks-textarea {
  min-height: 17rem !important;
}
.status-field {
  margin-top: 40px;
}
.checklist-title-input {
  width: 80%;
  z-index: 5;
}
.checklist-title {
  z-index: 2;
  cursor: pointer;
}
.checklist-option-input-wrapper {
  flex: 1;
}
button.btn.close-btn {
  right: -2.5rem;
  top: -2rem;
  background: none;
}
.save-button-row {
  padding-left: 30px;
  .save-button {
    background: $button-secondary;
  }
}
@media screen and (max-width: 991px) {
  .add-task-container {
    left: 0;
    width: 100%;
  }
  .add-task-container,
  .view-task-container {
    top: 18rem;
  }
}
@media screen and (max-width: 599px) {
  .add-task-container {
    height: 100vh;
  }
}
</style>
